import React from 'react'
import './NavItems.css'
import NavItem from './NavItem/NavItem'

const NavItems = (props) => {
    return(
        <div className="NavItems">
            <NavItem location="/" name="Home" exact />
            <NavItem location="/projects" name="Project"  />
            <NavItem location="/about" name="About Us"  />
            <NavItem location="/contact" name="Contact Us"/>
            <NavItem location="/donate" name="Donate"/>
        </div>
    )
}


export default NavItems